<template>
    <div class="main">
        <div class="bg-white">

            <!-- Hero & active addresses toggle -->
            <div class="container accountDeliveryAddresses__container mx-auto text-center p-4 py-0 pb-4">
                <h2 v-text="$t('RESTART_PAGE_ALL_SET_UP')"></h2>
                <p class="py-4 w-full" v-text="$t('RESTART_PAGE_RESTARTED')"></p>
            </div>

            <!-- Active addresses -->
            <div class="background--paper divider--container py-4">
                <div class="divider-white--top"></div>
                    <div class="mx-auto text-center pt-4 px-4">
                        <h2 class="pt-4" v-text="$t('RESTART_PAGE_DOUBLE_CHECK')"></h2>
                        <p class="pt-4" v-text="$t('RESTART_PAGE_DELIVERING', {
                            'getNamedDate': $t(`${getNamedDate}`),
                        })"></p>
                        <!-- 'getNamedDate': this.$t(`${this.getNamedDate}`), -->
                    </div>
                    <div class="container accountDeliveryAddresses__container
                    mx-auto text-center pt-4 pb-12 px-4">
                        <address-list
                            :subscriptions="activeSubscriptions"
                            type="active">
                        </address-list>

                        <p v-text="$t('RESTART_PAGE_NUMBER')"></p>
                        <p>--- --- --- {{authUser.card_ending}}</p>
                        <a class="link" @click="goToCardDetailsPage" v-text="$t('RESTART_PAGE_CARD_DETAILS')"></a>

                    </div>
                <div class="divider-white--bottom"></div>
            </div>
        </div>

        <!-- Billing details -->
        <div class="bg-white pl-8 pr-8 pt-16 pb-20" id="manageBllingContainer">
            <div class="container accountDeliveryAddresses__container mx-auto text-center">
                <h2 class="px-2" v-text="$t('RESTART_PAGE_HUNKY_DORY')"></h2>
                <div class="sm:w-1/2 mx-auto px-4 pt-4 pb-8">
                    <router-link :to="{ name: 'account.dashboard' }"
                                 tag="button"
                                 v-text="$t('RESTART_PAGE_TO_THE_DASH')"
                                 class="btn btn--full-width btn--primary btn--hoverable">
                    </router-link>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import AddressList from '@/components/partials/account/my-delivery-addresses/AddressList';

export default {
    name: 'MyDeliveryAddresses',
    data() {
        return {
            showActiveSubscriptions: true,
            showInactiveSubscriptions: false,
            showCreateAddressForm: false,
        };
    },
    methods: {
        // Toggle showing the create address form.
        toggleCreateForm() {
            this.showCreateAddressForm = !this.showCreateAddressForm;
        },

        // Goes to the card details on the Manage Account page.
        goToCardDetailsPage() {
            this.expandFormName = 'billingAddressForm';
            this.$router.push({ name: 'account.manage-account' });
        },
    },
    computed: {
        ...mapGetters({
            activeSubscriptions: 'subscription/getActiveSubscriptions',
            inactiveSubscriptions: 'subscription/getInactiveSubscriptions',
        }),

        activeSubscription() {
            return this.$store.getters['subscription/getActiveSubscription'];
        },

        authUser() {
            return this.$store.getters['account/getUser'];
        },

        getNamedDate() {
            return this.activeSubscription && this.$moment(this.activeSubscription.next_delivery_date).format('dddd');
        },
    },
    components: {
        AddressList,
    },
};
</script>
